import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue';
import ConfirmAccountEmailService from './confirmaccountemail.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmAccountEmail',
  props: {
    title: null,
    token: null,
    headline: null,
    subHeadline: null,
    goBackLinkText: null,
    goBackLinkUrl: null
  },
  setup(__props: any) {

const props = __props as {
    title: string;
    token: string;
    headline: string;
    subHeadline: string;
    goBackLinkText: string;
    goBackLinkUrl: string;
}




onMounted(async() => {
    await submit();
});

const showSpinner = ref(false);
const errorMessage = ref<string>('');
const successMessage = ref<boolean>(null);

async function submit() {
    errorMessage.value = '';
    showSpinner.value = true;

    const token = props.token;
    const serverResponse = await ConfirmAccountEmailService.confirmAccountEmail(token)
        .finally(() => showSpinner.value = false);

    successMessage.value = serverResponse.confirmAccountEmailSuccess;
};


return { __sfc: true,props, showSpinner, errorMessage, successMessage, submit }
}

})